import { getMe, getUser } from "../account/AccountAPI";

export type Group = {
  ctime: number;
  creator: string;
  id: number;
  name: string;
}

export const getGroups = async (sessionToken: string): Promise<Group[]> => {
  try {
    const me = await getMe(sessionToken)
    const profile = me.profile
    const groups: Group[] = []
    if (profile === "employee" || profile === "admin") {
      groups.push({
        id: 1,
        name: "Dipendenti",
        ctime: 0,
        creator: "system"
      });
    }
    if (profile === "admin") {
      groups.push({
        id: 2,
        name: "Amministrazione",
        ctime: 0,
        creator: "system"
      });
    }
    const meDetailed = await getUser(me.id, sessionToken)
    if (meDetailed.assistence) {
      groups.push({
        id: 3,
        name: "Assistenza",
        ctime: 0,
        creator: "system"
      });
    }
    return groups
  } catch (error) {
    throw new Error("Token non valido o scaduto");
  }
}